import { create } from 'zustand';

interface ProjectStore {
    name: string;
    setName: (obj: string) => void;

    updatedAt: string;
    setUpdatedAt: (obj: string) => void;

    createdAt: string;
    setCreatedAt: (obj: string) => void;

}

const useProjectStore = create<ProjectStore>((set) => ({
    name: '',
    setName: (obj) => set({ name: obj }),

    updatedAt: '',
    setUpdatedAt: (obj) => set({ updatedAt: obj }),

    createdAt: '',
    setCreatedAt: (obj) => set({ createdAt: obj }),

}));

export default useProjectStore;
